import CitySEOHead from "@/components/feature/CitySEOHead";
import HeroSection from "./components/HeroSection";
import StickyNav from "./components/StickyNav";
import ProcessingTimeSection from "./components/ProcessingTimeSection";
import ServicesSection from "./components/ServicesSection";
import HowItWorksSection from "./components/HowItWorksSection";
import LocalAreaSection from "./components/LocalAreaSection";
import TestimonialsSection from "./components/TestimonialsSection";
import AcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import ComparisonSection from "./components/ComparisonSection";
import MistakesSection from "./components/MistakesSection";
import FAQSection from "./components/FAQSection";
import HelpfulResourcesSection from "./components/HelpfulResourcesSection";
import FinalCTA from "./components/FinalCTA";

const anchorageFaqs = [
  { q: "How do I get an expedited passport in Anchorage, Alaska?", a: "Anchorage residents can use Fast Passport Center for 2–9 day expedited processing. Ship documents overnight and we handle agency submission remotely. The nearest regional agency is in Seattle, over 1,400 miles away." },
  { q: "Where is the nearest passport agency to Anchorage?", a: "The Seattle Regional Passport Agency (915 2nd Ave, Seattle, WA 98174) is the nearest agency to Anchorage — requiring a full flight. Fast Passport Center eliminates that trip entirely." },
];

const anchorageServices = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens." },
  { name: "New Passport", description: "First-time passport application assistance." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service." },
  { name: "Child Passport", description: "Passport services for minors under 16." },
  { name: "Name Change", description: "Passport correction and name change service." },
  { name: "Second Passport & Damaged", description: "Second passport issuance and damaged passport replacement." },
];

export default function AnchoragePage() {
  return (
    <>
      <CitySEOHead
        city="Anchorage"
        state="Alaska"
        stateAbbr="AK"
        route="/cities/anchorage"
        title="Emergency Passport Anchorage, AK — Expedited & Fast Passport Service | Fast Passport Center"
        description="Fast Passport Center provides emergency, expedited, and same-day passport services in Anchorage, Alaska. Serving Municipality of Anchorage, Eagle River, Wasilla, Palmer, and all Southcentral Alaska. As fast as 24 hours — no Seattle agency trip needed."
        geoPlacename="Anchorage, Alaska"
        geoPosition="61.2181;-149.9003"
        faqs={anchorageFaqs}
        servicesSchema={anchorageServices}
        statePageName="Alaska"
        statePageRoute="/states/alaska"
      />
      <div className="min-h-screen bg-white">
        <HeroSection />
        <StickyNav />
        <ProcessingTimeSection />
        <LocalAreaSection />
        <ServicesSection />
        <HowItWorksSection />
        <TestimonialsSection />
        <AcceptanceFacilitiesSection />
        <ComparisonSection />
        <MistakesSection />
        <FAQSection />
        <HelpfulResourcesSection />
        <FinalCTA />
      </div>
    </>
  );
}